const ns = '[Snapshots] ';

export const INITIAL_SNAPSHOTS = `${ns}initial snapshots`;
export const TAKE_SNAPSHOTS = `${ns}take snapshots`;
export const SET_DIAGRAM_SAVED = `${ns}set diagram saved`;
export const UNDO = `${ns}undo`;
export const REDO = `${ns}redo`;
